module.exports = __webpack_public_path__ + "static/media/man-and-woman-wearing-black-and-white-striped-aprons-2696064.a3c1446b.jpg";